class MostFrequentlyUsed {
    static _key = "mfu"

    constructor(name, items) {
        this.name = name
        this.items = items
        this.hash = MostFrequentlyUsed._getObject()
        this.items.forEach(it => {
            if (!this.hash.hasOwnProperty(it)) {
                this.hash[it] = 0
            }
        })
    }

    use(item) {
        if (this.hash.hasOwnProperty(item)) {
            this.hash[item] = this.hash[item] + 1
        }
        else {
            this.hash[item] = 1
        }
        MostFrequentlyUsed._setObject(this.hash)
    }

    /**
     * Sort the provided array according to the usage, and returns a shallow copy of the
     * provided array.
     * 
     * @param {[String]} items Array of strings to sort by the usage history
     */
    sort(items) {
        const result = items.slice()
        result.sort(this.compare)
        return result
    }

    sortAll() {
        const result = Object.keys(this.hash)
        result.sort(this.compare)
        return result
    }

    compare(a, b) {
        if (this.hash[a] < this.hash[b]) {
            return -1
        }
        else if (this.hash[a] > this.hash[b]) {
            return 1
        }
        return 0
    }

    static _getObject() {
        try {
            const prefs = JSON.parse(localStorage.getItem(MostFrequentlyUsed._key))
            if (prefs) {
                return prefs
            }
        }
        catch(e) {}
        return {}
    }
    static _setObject(obj) {
        try {
            localStorage.setItem(MostFrequentlyUsed._key, JSON.stringify(obj))
        }
        catch(e) {}
    }

    static resetAll() {
        try {
            localStorage.removeItem(MostFrequentlyUsed._key)
        }
        catch(e) {}
    }
}

export default MostFrequentlyUsed
